import { type StackProps, Typography, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import CircularProgress from '@mui/material/CircularProgress'
import { IconButton } from 'settle-ui/components/IconButton/IconButton'
import { Button as SuiButton } from 'settle-ui/components/Button/Button'
import type { SnackbarVariant } from 'settle-ui/hooks/useSnackbarsStore/useSnackbarsStore.types'
import { youShallNotPass } from 'lib/helpers/youShallNotPass/youShallNotPass'
import * as tkn from './Snackbar.tokens'

export interface RootProps extends StackProps {
  variant: SnackbarVariant
}

export const Root = styled(Stack, {
  shouldForwardProp: youShallNotPass('variant'),
})<RootProps>(({ theme, ...props }) => ({
  paddingLeft: tkn.SnackbarSpacingMediumDesktopHorizontal,
  paddingRight: tkn.SnackbarSpacingMediumDesktopHorizontal,
  paddingTop: tkn.SnackbarSpacingMediumDesktopVertical,
  paddingBottom: tkn.SnackbarSpacingMediumDesktopVertical,
  minHeight: tkn.SnackbarSizeDesktop,
  minWidth: '428px',
  flexGrow: 1,
  alignItems: 'center',
  borderRadius: tkn.SnackbarBorderRadiusDesktop,
  boxShadow: `
      0px 3px 5px -1px rgba(0,0,0,0.2),
      0px 6px 10px 0px rgba(0,0,0,0.14),
      0px 1px 18px 0px rgba(0,0,0,0.12)`,
  textAlign: 'left',
  ...(props.variant === 'error' && {
    backgroundColor: tkn.SnackbarColorErrorBackground,
    color: tkn.SnackbarColorErrorOnBackground,
  }),
  ...(props.variant === 'alert' && {
    backgroundColor: tkn.SnackbarColorSuccessBackground,
    color: tkn.SnackbarColorSuccessOnBackground,
  }),
  ...(props.variant === 'warning' && {
    backgroundColor: tkn.SnackbarColorWarningBackground,
    color: tkn.SnackbarColorWarningOnBackground,
  }),
  ...(props.variant === 'info' && {
    backgroundColor: tkn.SnackbarColorInfoBackground,
    color: tkn.SnackbarColorInfoOnBackground,
  }),
  ...(props.variant === 'upsell' && {
    // TODO: Replace with design tokens once added to the design system (DES-1862)
    backgroundColor: '#e8f0ed',
    color: '#004D3B',
  }),
  [theme.breakpoints.down('md')]: {
    minWidth: '320px',
  },
}))

export const Content = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexGrow: 1,
  width: '100%',
}))

export const Message = styled(Typography)(() => ({
  flexGrow: 1,
  color: 'inherit',
}))

export const Spinner = styled(CircularProgress)(() => ({
  flexShrink: 0,
  color: 'inherit',
}))

export const Close = styled(IconButton)(() => ({
  flexShrink: 0,
  color: 'inherit',
  '&:hover': {
    color: 'inherit',
  },
}))

export const Button = styled(SuiButton)(() => ({
  minWidth: 'auto',
  color: 'inherit',
  '&:hover': {
    color: 'inherit',
  },
}))
